<template>
  <vue-admin-tasks-base-task-card ref="baseTaskCard" :error="taskData.error" :loading="taskData.isLoading">
    <template v-slot:header>
      <div class="d-flex">
        <div class="input-group flex-grow-1">
          <input type="text" :class="`form-control title-new-task-card ${validations.title ? '' : 'invalid'}`" :placeholder="$t('titlePlaceholder')" v-model="title">
        </div>
        <div>
          <vue-admin-tasks-task-card-menu :taskData="taskData">
            <template v-slot:wrapper>
              <a class="link-dark"><i class="bi bi-three-dots-vertical"></i></a>
            </template>
          </vue-admin-tasks-task-card-menu>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="new-card-body-content">
        <div pb="1">
          <vue-admin-tasks-time-task v-model="duration" :valid="validations.duration"></vue-admin-tasks-time-task>
        </div>
        <div class="flex-grow-1">
          <div class="input-group">
            <textarea :placeholder="$t('descriptionPlaceholder')" :class="`description-new-task-card ${validations.description ? '' : 'invalid'}`" v-model="description">
              
            </textarea>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <div class="flex-grow-1">
          <vue-admin-tasks-task-tags :task-data="taskData"></vue-admin-tasks-task-tags>
        </div>
        <div ml="0.5">
          <button href="#" class="font-bold button-means-link link-dark-blue" @click="save()">{{ $t('save') }}</button>
        </div>
      </div>
    </template>
  </vue-admin-tasks-base-task-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default{
  data: function(){
    return {
      title: this.taskData.title,
      description: this.taskData.description,
      duration: this.taskData.duration,
      validations: {
        title: true,
        description: true,
        duration: true
      }
    }
  },
  props: {
    taskData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('taskStoreModule', ['dateSelected']),
  },
  methods: {
    ...mapActions('taskStoreModule', ['createTask', 'updateTask']),
    newTask(){
      this.createTask({
        renderId: this.taskData.renderId,
        task: {
          title: this.title, 
          description: this.description, 
          duration: this.duration,
          scheduled_to: JSON.stringify(this.dateSelected),
          task_tags_attributes: this.taskData.tags.map(tag=> ({tag_id: tag.id}))
        },
        onSuccess: () => {
          this.clearData();
        }
      })
    },
    update(){
      this.updateTask({
        task_id: this.taskData.id,
        renderId: this.taskData.renderId,
        task: {
          id: this.taskData.id,
          title: this.title, 
          description: this.description, 
          duration: this.duration,
          scheduled_to: JSON.stringify(this.dateSelected),
        }
      })
    },
    save(){
      if(this.validateData()){
        if(!this.taskData.editing){
          this.newTask()
        }else{
          this.update()
        }
      }
    },
    validateData(){
      this.validations.title = (this.title=="" || this.title==null) ? false : true
      this.validations.description = (this.description=="" || this.description==null) ? false : true
      this.validations.duration = (this.duration==0) ? false : true
      return this.validations.title && this.validations.description && this.validations.duration
    },
    clearData(){
      this.title=""
      this.duration=0
      this.description=""
      this.tags = [];
    }
  },
  i18n: {
    messages: {
      "pt-BR": {
        titlePlaceholder: 'Em que vamos trabalhar?',
        descriptionPlaceholder: 'Descreva sua atividade',
        saveError: 'Ocorreu um erro ao adicionar uma nova tarefa'
      },
      en: {
        titlePlaceholder: 'What do you want to do?',
        descriptionPlaceholder: 'Describe your activity',
        saveError: 'A error was occurred when adding a new task'
      }
    }
  }
}
</script>
